import Subsection, {
	type SubsectionProps,
} from 'components/containers/sub-section';
import Shelf, { type ShelfProps } from 'components/containers/shelf';

const ShelfSubsection = ({
	autoSizeItems = false,
	autoSizedVisibleItemCount = 2,
	children,
	...restProps
}: IProps) => {
	return (
		<Subsection {...restProps} hasClampedWidth={false}>
			<Shelf
				autoSizeItems={autoSizeItems}
				autoSizedVisibleItemCount={autoSizedVisibleItemCount}
			>
				{children}
			</Shelf>
		</Subsection>
	);
};

interface IProps extends SubsectionProps {
	hasClampedWidth?: never;
	autoSizeItems?: ShelfProps['autoSizeItems'];
	autoSizedVisibleItemCount?: ShelfProps['autoSizedVisibleItemCount'];
}

export default ShelfSubsection;
